import { useT } from "../i18n";

/**
 * SpoilerNote sits above an open answer on a book that tells a story (owner,
 * 2026-10-20). Open reads the whole book (ADR-0188), so the answer may give
 * away what is ahead of the reader — and the note says how to stop that: a tap
 * switches the conversation to spoiler-free for the next question. With no
 * `onSpoilerFree` the conversation is already spoiler-free, so the way out
 * would be a stale instruction, and only the warning is shown.
 */
export default function SpoilerNote({ onSpoilerFree }: { onSpoilerFree?: () => void }) {
  const t = useT();
  return (
    <p
      className="mb-1.5 flex items-start gap-1.5 text-xs text-muted"
      data-testid="ask-spoiler-note"
    >
      <span aria-hidden="true">⚠</span>
      <span>
        {t.chat.spoilerNote}{" "}
        {onSpoilerFree && (
          <button
            type="button"
            onClick={onSpoilerFree}
            data-testid="ask-spoiler-switch"
            className="text-start underline decoration-line underline-offset-2 hover:text-ink"
          >
            {t.chat.spoilerSwitch(t.chat.modeSpoilerFree)}
          </button>
        )}
      </span>
    </p>
  );
}

/** Whether an answer gets the note: an open one, on a book that tells a story. */
export function showsSpoilerNote(answer: { mode?: string }, story: boolean): boolean {
  return story && answer.mode === "open";
}
